module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.c5a1649c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-italic-webfont.ttf
// module id = 277
// module chunks = 0